import { initializeApp } from "firebase/app";
import { ReCaptchaEnterpriseProvider, initializeAppCheck } from "firebase/app-check";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getFunctions } from "firebase/functions";
import { getStorage } from "firebase/storage";

const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
};

if (!firebaseConfig.apiKey || !firebaseConfig.projectId) {
  console.error("Falta la configuración de Firebase. Revisá las variables REACT_APP_FIREBASE_* en .env");
} else if (firebaseConfig.projectId !== firebaseConfig.projectId.toLowerCase()) {
  // Los IDs de proyecto de Firebase siempre van en minúsculas: con mayúsculas Firestore responde "permission-denied".
  console.error(`[OdontoSend] REACT_APP_FIREBASE_PROJECT_ID="${firebaseConfig.projectId}" no es válido: tiene que ir en minúsculas.`);
}

export const PROJECT_ID = firebaseConfig.projectId;

const app = initializeApp(firebaseConfig);

// App Check (reCAPTCHA Enterprise, invisible): lo exigen solo las funciones públicas del link de recepción
// (/l/{nombre}). Sin clave configurada (por ejemplo, en desarrollo) no se inicializa.
const appCheckKey = process.env.REACT_APP_RECAPTCHA_ENTERPRISE_KEY;
if (appCheckKey && typeof window !== "undefined") {
  initializeAppCheck(app, { provider: new ReCaptchaEnterpriseProvider(appCheckKey), isTokenAutoRefreshEnabled: true });
}

export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);
// Misma región que las Cloud Functions (functions/index.js).
export const functions = getFunctions(app, "southamerica-east1");
